












import { Component } from 'vue-property-decorator';
import Mixin from '@/mixin';
import menuModule from '@/store/modules/common/menu.module';

@Component({
  name: 'v-loading'
})
export default class VLoading extends Mixin {
  public percent = 0;

  get show(): boolean | null {
    return menuModule.isShowLoading;
  }

  public updatePercent() {
    if (this.percent < 100) {
      this.percent += 3;
    }
  }

  mounted() {
    this.percent = 0;
    setInterval(() => {
      this.updatePercent();
    }, 100);
  }
}
